import createReactComponent from '../createReactComponent';
export default createReactComponent('zodiac-taurus', 'IconZodiacTaurus', [
  ['path', { d: 'M6 3a6 6 0 0 0 12 0', key: 'svg-0' }],
  ['path', { d: 'M12 15m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0', key: 'svg-1' }],
]);
